/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: SalesTotalsbyAmountAddComponent
 * Purpose		: This component retrieves specified record and shows details.
 * Dependency	: SalesTotalsbyAmountService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/

import { Component, OnInit, HostBinding, EventEmitter, Input, Output,
         trigger, transition, animate,
         style, state } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/switchMap';
import { ToastsManager }  from 'ng2-toastr';
import { SalesTotalsbyAmountData, SalesTotalsbyAmountService }  from './SalesTotalsbyAmount.service';


@Component({
  template: require('./SalesTotalsbyAmountDetails.component.html'),
  providers: [SalesTotalsbyAmountService
	
	],
  animations: [
    trigger('routeAnimation', [
      state('*',
        style({
          opacity: 1,
          transform: 'translateX(0)'
        })
      ),
      transition(':enter', [
        style({
          opacity: 0,
          transform: 'translateX(-100%)'
        }),
        animate('0.2s ease-in')
      ]),
      transition(':leave', [
        animate('0.5s ease-out', style({
          opacity: 0,
          transform: 'translateY(100%)'
        }))
      ])
    ])
  ]
})

export class SalesTotalsbyAmountDetailsComponent implements OnInit {
	@HostBinding('@routeAnimation') get routeAnimation() {
		return true;
	}

	@HostBinding('style.display') get display() {
		return 'block';
	}

	// @HostBinding('style.position') get position() {
	//  return 'absolute';
	// }

	objSalesTotalsbyAmount: SalesTotalsbyAmountData;
	errorMessage: string;
	messages: string[];

	// Lookup Arrays
	

	constructor(private route: ActivatedRoute, 
		private router: Router,
		private toastr: ToastsManager,
		private SalesTotalsbyAmountService: SalesTotalsbyAmountService

	) {
		// this.id = parseInt(params.get('id'));
		this.objSalesTotalsbyAmount = new SalesTotalsbyAmountData();
	}

	ngOnInit() {
		this.route.params
		// (+) converts string 'id' to a number
		// .switchMap((params: Params) => this.SalesTotalsbyAmountService.getByID(+params['id']))
		.switchMap((params: Params) => this.SalesTotalsbyAmountService.getByID(params['id']))
		.subscribe((item: SalesTotalsbyAmountData) => this.objSalesTotalsbyAmount = item);
		this.getLookups();
	}

	deleteSalesTotalsbyAmount(id: string) {
		if (window.confirm('Are you sure you want to delete this SalesTotalsbyAmount?') == true) 
		{
			this.SalesTotalsbyAmountService.deleteSalesTotalsbyAmount(this.objSalesTotalsbyAmount.SaleAmount.toString())
			.subscribe(record => this.router.navigate(['/SalesTotalsbyAmount']),
				error =>  this.errorMessage = 'There was an error while deleting record. Error: ' + <any>error,
				() => { console.log('SalesTotalsbyAmount record deleted successfully...'); }
			);
		}
	}
	gotoSalesTotalsbyAmountEdit() {
		this.router.navigate(['/SalesTotalsbyAmount', this.objSalesTotalsbyAmount.SaleAmount]);
	}

	gotoSalesTotalsbyAmount() {
		this.router.navigate(['/SalesTotalsbyAmount']);
	}


	getLookups() {

	}

	log(msg: string) {
		this.messages.splice(0, 0, msg);
		console.log(msg);
	}
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/SalesTotalsbyAmount/SalesTotalsbyAmountDetails.component.ts